import { PublishedResults } from '../../../components/results/shared/PublishedResults';

export default function ParentViewCBT() {
  return <PublishedResults assessmentType="cbt" audience="parent" />;
}
